import React from "react";
import { Container, Table } from "react-bootstrap";

function ComplianceOffice() {
  return (
    <>
      <section className="complianceOfficer">
        <Container className="complianceOfficerDataTable">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.N.</th>
                <th>Contact Name</th>
                <th>Exchance</th>
                <th>Contact Number</th>
                <th>Contact Mail</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Devansh Gupta</td>
                <td>BSE</td>
                <td>9311786324</td>
                <td>algoquantglobal@gmail.com</td>
              </tr>
            </tbody>
          </Table>
        </Container>
      </section>
    </>
  );
}

export default ComplianceOffice;
